var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLwa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_417_12)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8739 11.6656C14.8739 13.0899 14.9091 14.2753 14.191 15.5415C13.6104 16.5688 12.6872 17.2021 11.6621 17.2021C10.2611 17.2021 9.44063 16.134 9.44063 14.552C9.44063 11.4403 12.2322 10.875 14.8739 10.875V11.6656ZM18.5579 20.5729C18.3164 20.7898 17.875 20.7973 17.6949 20.6581C16.4467 19.6923 15.6008 18.2236 15.6008 18.2236C13.595 20.2663 12.1746 20.8799 9.57723 20.8799C6.50153 20.8799 4.10922 18.9808 4.10922 15.1852C4.10922 12.2193 5.71493 10.2026 8.00534 9.21436C9.987 8.34387 12.7561 8.18576 14.8739 7.94815C14.8739 7.94815 15.0514 5.65906 14.4304 4.82458C13.9494 4.17764 13.1312 3.87504 12.3802 3.87504C11.0248 3.86977 9.71558 4.60674 9.45557 6.02447C9.38135 6.42985 9.08181 6.77067 8.76647 6.73641L5.26782 6.35738C4.99991 6.3262 4.63626 6.04994 4.72234 5.59318C5.53617 1.29783 9.41516 0 12.8923 0C14.6697 0 16.9935 0.473894 18.395 1.81916C20.1715 3.47976 20.0016 5.69463 20.0016 8.10714V13.7983C20.0016 15.5111 20.7122 16.2617 21.3793 17.1836C21.6125 17.5169 21.6657 17.9118 21.3684 18.1547C20.6217 18.7805 18.5579 20.5729 18.5579 20.5729Z",
    fill: "#16191F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7336 24.5434C20.8589 26.6651 16.6914 27.7931 13.1026 27.7931C8.07292 27.7931 3.54363 25.9339 0.116281 22.8393C-0.152855 22.596 0.0870115 22.2644 0.410638 22.4524C4.10859 24.6042 8.68151 25.9 13.4047 25.9C16.5907 25.9 20.0929 25.2389 23.3158 23.8719C23.8017 23.6659 24.2093 24.192 23.7336 24.5434Z",
    fill: "#16191F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9298 23.1777C24.5622 22.7072 22.4995 22.9549 21.5726 23.0658C21.292 23.0996 21.2486 22.8542 21.5015 22.6766C23.1471 21.5207 25.8434 21.8545 26.1567 22.2416C26.4723 22.6319 26.0737 25.335 24.5318 26.6251C24.2945 26.8234 24.0686 26.7175 24.1741 26.4556C24.5211 25.5891 25.2978 23.649 24.9298 23.1777Z",
    fill: "#16191F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_417_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLwa);
export default __webpack_public_path__ + "static/media/lwa.344f73e901c5d9f663b41bccb1dbeef8.svg";
export { ForwardRef as ReactComponent };